/**
 * VerticalTabBar - Left-edge tab icons for the Expanding Card
 *
 * Four icon buttons arranged vertically. Active tab is highlighted.
 * Clicking a tab toggles the detail panel (expand/collapse).
 */

import { Plane, DollarSign, User, Calendar, Fuel } from 'lucide-react'
import { useAircraftCardStore, type TabId } from '@/stores/aircraftCardStore'

const TAB_CONFIG: { id: TabId; icon: typeof Plane; label: string }[] = [
  { id: 'aircraft', icon: Plane, label: 'Aircraft' },
  { id: 'financial', icon: DollarSign, label: 'Financial' },
  { id: 'fuel', icon: Fuel, label: 'Fuel' },
  { id: 'client', icon: User, label: 'Client' },
  { id: 'schedule', icon: Calendar, label: 'Schedule' },
]

export function VerticalTabBar() {
  const cardState = useAircraftCardStore((s) => s.cardState)
  const toggleTab = useAircraftCardStore((s) => s.toggleTab)

  const activeTab =
    cardState.mode === 'expanded' ? cardState.activeTab : null

  return (
    <div className="w-10 flex flex-col gap-1 p-1 border-r">
      {TAB_CONFIG.map(({ id, icon: Icon, label }) => {
        const isActive = activeTab === id
        return (
          <button
            key={id}
            onClick={() => toggleTab(id)}
            title={label}
            className={`w-8 h-8 flex items-center justify-center rounded transition-colors ${
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Icon className="w-4 h-4" />
          </button>
        )
      })}
    </div>
  )
}
